import { SUBSCRIPTION_ENDPOINTS } from './endpoints.js';
/**
 * Subscription API Client
 * Encapsulates all subscription-related API calls.
 */
export class SubscriptionClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * Get the current user's subscription state.
     * Corresponds to: GET /api/subscription/state
     */
    async getState() {
        const response = await this.httpClient.get(SUBSCRIPTION_ENDPOINTS.GET_STATE);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to get subscription state');
        }
        return response.data;
    }
    /**
     * Get the current active subscription cycle for the authenticated user.
     * Corresponds to: GET /api/subscription/cycles/user/current
     */
    async getCurrentCycle() {
        const response = await this.httpClient.get(SUBSCRIPTION_ENDPOINTS.GET_CURRENT_CYCLE);
        if (!response.success || !response.data) {
            throw new Error(response.error || 'Failed to get current subscription cycle');
        }
        return response.data;
    }
}
//# sourceMappingURL=client.js.map